module.exports = __webpack_public_path__ + "img/ee381be.jpg";